// NotificationDetail.jsx — modal de détail d'une notification.
// `mode` = "sheet" (feuille montante, défaut) | "center" (dialogue centré).
import React from "react";
import { Ico, TYPES } from "./notificationsShared";
import DailyRecapDetail from "../../components/DailyRecapDetail";
import { formatDailyRecapDate } from "../../utils/dailyRecapDisplay";

export default function NotificationDetail({ n, mode = "sheet", onClose, onToggleRead, onDelete, onOpenEntity }) {
  const T = n ? TYPES[n.type] : null;
  const isDailyRecap = n?.sourceType === "daily_recap";
  const dailyRecapDateValue = isDailyRecap
    ? n.data?.recap_date || n.createdAt
    : null;
  const dailyRecapDate = dailyRecapDateValue
    ? formatDailyRecapDate(n.data?.recap_date || n.createdAt)
    : "";
  return (
    <div className={"modal-host modal-host--" + mode + (n ? " open" : "")} role="dialog" aria-modal="true">
      <div className="modal-scrim" onClick={onClose} />
      <div className="modal">
        {n && (
          <>
            <div className={"modal__band " + T.cls}>
              {mode === "sheet" && <div className="modal__grip" />}
              <button className="modal__close" aria-label="Fermer" onClick={onClose}><Ico name="x" /></button>
              <div className="modal__head">
                <span className={"nic " + T.cls}><Ico name={T.ic} /></span>
                <div className="modal__headt">
                  <span className="modal__eyebrow">
                    {isDailyRecap ? "Bilan journalier" : T.label}
                  </span>
                  <h2>
                    {isDailyRecap
                      ? dailyRecapDate
                        ? `Clôture du ${dailyRecapDate}`
                        : "Bilan journalier"
                      : n.title}
                  </h2>
                </div>
              </div>
              <div className="modal__sub">
                <span><Ico name="building-2" />{n.org}</span>
                <span><Ico name="clock" />{n.time}</span>
              </div>
            </div>

            <div className="modal__body">
              {isDailyRecap ? (
                <DailyRecapDetail
                  data={n.data}
                  message={n.msg}
                  createdAt={n.createdAt}
                  warehouseNameFallback={n.warehouseName}
                />
              ) : (
                <>
                  <p className="dmsg">{n.msg}</p>
                  <div className="dl">
                    {n.detail.map((d, i) => (
                      <div className="dl-row" key={i}>
                        <span className="dl-k"><Ico name={d.ic} />{d.k}</span>
                        <span className={"dl-v" + (d.amount ? " amount" : "")}>{d.v}</span>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>

            <div className="modal__foot">
              <button className="btn btn--primary" onClick={() => { onOpenEntity?.(n); onClose(); }}>
                <Ico name={n.cta.ic} />{n.cta.label}
              </button>
              <button className="btn btn--ghost" onClick={() => onToggleRead(n)}>
                <Ico name={n.read ? "rotate-ccw" : "check-check"} />
                {n.read ? "Non lu" : "Marquer lu"}
              </button>
              <button className="btn btn--icon btn--danger-ghost"
                onClick={() => { onDelete(n); onClose(); }} aria-label="Supprimer">
                <Ico name="trash-2" />
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
